import gql from "graphql-tag";

const STAFF_TYPE_PROPS = gql`
	fragment staffType on StaffType {
		id
		name
		created_at
	}
`;

export const GET_STAFF_TYPE = gql`
	query GetStaffTypes($siteId: ID!) {
		GetAllStaffType(site: $siteId) {
			docs {
				...staffType
			}
		}
	}
	${STAFF_TYPE_PROPS}
`;

export const NEW_STAFF_TYPE = gql`
	mutation CreateStaffType($name: String!, $site: ID!) {
		CreateStaffType(name: $name, site: $site) {
			message
			doc {
				...staffType
			}
		}
	}
	${STAFF_TYPE_PROPS}
`;

export const UPDATE_STAFF_TYPE = gql`
	mutation UpdateStaffType($id: ID!, $name: String!) {
		UpdateStaffType(id: $id, name: $name) {
			message
			doc {
				...staffType
			}
		}
	}
	${STAFF_TYPE_PROPS}
`;
